// Copyright (c) 2019 Comsearch, Inc., All rights reserved

const paginateData = (data, formValues) => {
  // if there's no data to paginate,
  // if the form hasn't been initialized yet, or if
  // there is no specified page size, then we don't
  // need to worry about paginating this data
  if (!data.length || !formValues || !formValues.paginationSize) {
    return data
  }

  const {
    paginationPage,
    paginationSize,
  } = formValues

  const pageStartIndex = paginationSize * paginationPage

  // otherwise create a subset of the data based on the given pagination information.
  // reduce here allows us to properly handle when it's the last page and the count is
  // less than the given paginationSize.
  return (
    Array.from({ length: paginationSize })
      .reduce((a, d, i) => {
        if (data[pageStartIndex + i]) {
          a.push(data[pageStartIndex + i])
        }
        return a
      }, [])
  )
}

export default paginateData
